import { schema as schemas } from 'normalizr'
import { CallApi } from '@signavio/kraken'
import { Nullable } from '../../../types/nullable'
import qs from 'qs'

export const collection = 'references'

export const schema = new schemas.Array(
  new schemas.Entity(collection, {}, { idAttribute: ({ object }) => object.id })
)

type FetchQueryType = {
  serviceId: string
  accountId: string
  types: string
  parentId: Nullable<string>
  pathTo?: string
}

export const fetch =
  (callApi: CallApi, apiBase: string) =>
  ({ serviceId, accountId, types, parentId, pathTo }: FetchQueryType) =>
    callApi(
      `${apiBase}/services/${serviceId}/accounts/${accountId}/references${qs.stringify(
        {
          q: types,
          parent: parentId,
          pathTo,
        },

        { addQueryPrefix: true }
      )}`,
      schema
    )
